var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQbhouse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 217.846,
    height: 72,
    viewBox: "0 0 217.846 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a7ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#005bac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03004c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo_org",
    transform: "translate(-100.756 -496.795)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_479",
    "data-name": "\\u9577\\u65B9\\u5F62 479",
    width: 217.846,
    height: 72,
    transform: "translate(100.757 496.795)",
    fill: "#00004b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "SVGID",
    width: 39.323,
    height: 72,
    transform: "translate(101.079 496.795)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2883",
    "data-name": "\\u30D1\\u30B9 2883",
    d: "M305.363,544.937a8.449,8.449,0,0,0-3.644-3.276c1.972-.9,3.416-3.784,3.688-5.761a10.393,10.393,0,0,0-1.119-6.4,8.569,8.569,0,0,0-6.407-4.374c-2.077-.328-10.573-.261-12.993-.261h-5.925V561.6h14.584a23.841,23.841,0,0,0,6.233-.695A10.294,10.294,0,0,0,304,558.3a10.607,10.607,0,0,0,1.366-13.368m-19.872-13.98h8.69a5.435,5.435,0,0,1,3.756,1.151,4.318,4.318,0,0,1,1.239,3.385,4.611,4.611,0,0,1-1.214,3.485,5.692,5.692,0,0,1-3.99,1.165h-8.482ZM299.071,554.1c-1.023.858-2.7,1.293-4.972,1.293h-8.609v-9.6H293.5c2.725,0,4.615.468,5.624,1.394a4.421,4.421,0,0,1,1.538,3.441,4.342,4.342,0,0,1-1.59,3.472",
    transform: "translate(-80.633 -10.418)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2884",
    "data-name": "\\u30D1\\u30B9 2884",
    d: "M241.088,555.5a17.872,17.872,0,0,0,4.863-12.261,18.517,18.517,0,0,0-6.656-14.751,19.155,19.155,0,0,0-25.868.668A18.373,18.373,0,0,0,207.6,542.99a17.817,17.817,0,0,0,6.166,13.915,19.529,19.529,0,0,0,17.936,4.3,18.3,18.3,0,0,0,4.823-2.058l2.008,2.058h8.39Zm-4.561-4.665-2.316-2.306h-8.538l6.159,5.973a12.2,12.2,0,0,1-5.309,1.153,12.351,12.351,0,0,1-8.7-3.618,11.963,11.963,0,0,1-3.646-9,12.97,12.97,0,0,1,3.55-9.347A11.91,11.91,0,0,1,226.707,530a12.2,12.2,0,0,1,9.034,3.7,12.668,12.668,0,0,1,3.636,9.2,11.71,11.71,0,0,1-2.849,7.941",
    transform: "translate(-54.142 -10.022)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2885",
    "data-name": "\\u30D1\\u30B9 2885",
    d: "M344.525,559.232h-7.119v-6.64H334.13v18.669h3.276v-8.915h7.119v8.915H347.8V552.592h-3.276Z",
    transform: "translate(-101.113 -20.713)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2886",
    "data-name": "\\u30D1\\u30B9 2886",
    d: "M372.034,552.3a9.419,9.419,0,0,0-6.818,2.789,9.507,9.507,0,0,0,.279,13.841,9.725,9.725,0,0,0,13.275-.312,9.1,9.1,0,0,0,2.84-6.742,9.629,9.629,0,0,0-9.576-9.576m4.43,14.134a6.411,6.411,0,0,1-8.964-9.164,6.105,6.105,0,0,1,4.5-1.856,6.043,6.043,0,0,1,4.488,1.856,6.636,6.636,0,0,1-.022,9.164",
    transform: "translate(-111.594 -20.606)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2887",
    "data-name": "\\u30D1\\u30B9 2887",
    d: "M409.987,563.789a5.59,5.59,0,0,1-.7,3.193,3.73,3.73,0,0,1-5.852,0,5.684,5.684,0,0,1-.7-3.2v-11.2h-3.276v11.937a6.764,6.764,0,0,0,6.893,6.974,6.818,6.818,0,0,0,5.066-2.124,6.742,6.742,0,0,0,1.839-4.85V552.592h-3.277Z",
    transform: "translate(-125.367 -20.713)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2888",
    "data-name": "\\u30D1\\u30B9 2888",
    d: "M435.644,559.89l-1.78-.728c-1.186-.487-1.762-1.088-1.762-1.835a1.68,1.68,0,0,1,.639-1.352,2.454,2.454,0,0,1,1.672-.565,2.528,2.528,0,0,1,1.583.478,1.815,1.815,0,0,1,.744,1.149c.025.124.045.317.049.372.016.206.016.221.016.221h2.931s0-.053-.006-.221c-.005-.14-.02-.316-.037-.438a5.687,5.687,0,0,0-.468-1.661,5.047,5.047,0,0,0-4.789-3.026,5.862,5.862,0,0,0-4.019,1.437,4.6,4.6,0,0,0-1.637,3.583c0,2.108,1.293,3.723,3.845,4.8l1.72.716a7.434,7.434,0,0,1,1.112.584,3.289,3.289,0,0,1,.728.626,2.138,2.138,0,0,1,.4.7,2.729,2.729,0,0,1,.13.862,2.617,2.617,0,0,1-.748,1.935,2.786,2.786,0,0,1-4.083-.286,3.98,3.98,0,0,1-.678-1.768c-.014-.083-.03-.167-.046-.287s-.026-.218-.026-.218H427.9s.007.225.024.441c.019.248.041.385.059.514.024.177.085.476.141.719a6.3,6.3,0,0,0,1.812,3.294,5.794,5.794,0,0,0,4.034,1.451,5.94,5.94,0,0,0,4.308-1.7,5.757,5.757,0,0,0,1.729-4.279,5.134,5.134,0,0,0-1.069-3.285,7.905,7.905,0,0,0-3.3-2.234",
    transform: "translate(-135.924 -20.599)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2889",
    "data-name": "\\u30D1\\u30B9 2889",
    d: "M464.085,555.707v-3.114H453.651v18.668h10.434v-3.114h-7.157v-5.8h6.66v-3.115h-6.66v-3.525Z",
    transform: "translate(-145.482 -20.714)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_480",
    "data-name": "\\u9577\\u65B9\\u5F62 480",
    width: 39.647,
    height: 72,
    transform: "translate(100.756 496.795)",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQbhouse);
export default __webpack_public_path__ + "static/media/qbhouse.c6c9e936a5d45b95d6e93518c255079e.svg";
export { ForwardRef as ReactComponent };